"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));
var _AlertTitle = _interopRequireDefault(require("@material-ui/lab/AlertTitle"));
var _CheckCircleOutline = _interopRequireDefault(require("@material-ui/icons/CheckCircleOutline"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _classes = require("../../utils/classes");
var _excluded = ["children", "classes", "className", "dataMetrics", "icon", "onClose", "severity", "title"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = function useStyles(hasTitle) {
  return (0, _styles.makeStyles)(function (theme) {
    return {
      closeIcon: _objectSpread({}, hasTitle ? {
        alignSelf: 'flex-start',
        marginTop: theme.spacing(1.5)
      } : {
        alignSelf: 'center'
      }, {
        color: theme.palette.secondary.main
      }),
      filledError: {
        backgroundColor: theme.palette.accent.redLight,
        borderColor: (0, _styles.alpha)(theme.palette.accent.redMain, 0.3),
        color: theme.palette.accent.redMain
      },
      filledInfo: {
        backgroundColor: '#F0FAFE',
        borderColor: (0, _styles.alpha)(theme.palette.primary.main, 0.3),
        color: theme.palette.opacity.black[87]
      },
      filledSuccess: {
        backgroundColor: theme.palette.accent.greenLight,
        borderColor: (0, _styles.alpha)(theme.palette.accent.greenMain, 0.3),
        color: theme.palette.accent.greenMain
      },
      filledWarning: {
        backgroundColor: theme.palette.accent.orangeLight,
        borderColor: (0, _styles.alpha)(theme.palette.accent.orangeMain, 0.3),
        color: theme.palette.accent.orangeMain
      },
      icon: {
        fontSize: theme.spacing(3),
        padding: theme.spacing(1.5, 0)
      },
      iconInfo: {
        color: theme.palette.primary.main
      },
      message: {
        padding: theme.spacing(1.5, 0)
      },
      root: _objectSpread({}, !hasTitle && {
        alignItems: 'center',
        display: 'flex'
      }, {
        borderStyle: 'solid',
        borderWidth: '1px',
        padding: theme.spacing(0, 1.5)
      }),
      titleRoot: {
        marginBottom: theme.spacing(1)
      }
    };
  })();
};
var defaultProps = {
  dataMetrics: {
    root: 'fuse_alert',
    title: 'fuse_alert_title'
  },
  severity: 'success'
};

/**
 * An Alert displays a short, important message in a way that attracts the users's
 * attention without interrupting the user's task. These messages do not
 * self-dismiss and have the option to include a close "X".
 */
var _ref = /*#__PURE__*/_react["default"].createElement(_CheckCircleOutline["default"], null);
var Alert = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
    _props$classes = props.classes,
    propClasses = _props$classes === void 0 ? {} : _props$classes,
    className = props.className,
    dataMetrics = props.dataMetrics,
    icon = props.icon,
    onClose = props.onClose,
    severity = props.severity,
    title = props.title,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var classes = (0, _classes.mergeClasses)(useStyles(title !== undefined), propClasses);
  var iconMapping = {
    success: _ref
  };
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var closeAlert = function closeAlert(e) {
    setOpen(false);
    onClose(e);
  };
  if (!open) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_Alert["default"], (0, _extends2["default"])({
    classes: {
      action: classes.closeIcon,
      filledError: classes.filledError,
      filledInfo: classes.filledInfo,
      filledSuccess: classes.filledSuccess,
      filledWarning: classes.filledWarning,
      icon: (0, _classnames["default"])(classes.icon, (0, _defineProperty2["default"])({}, classes.iconInfo, severity === 'info')),
      message: classes.message,
      root: classes.root
    },
    className: className,
    "data-metrics": mergedDataMetrics.root,
    icon: icon,
    iconMapping: iconMapping,
    onClose: onClose && closeAlert,
    ref: ref,
    severity: severity,
    variant: "filled"
  }, rest), title && /*#__PURE__*/_react["default"].createElement(_AlertTitle["default"], {
    color: "inherit",
    className: classes.titleRoot,
    "data-metrics": mergedDataMetrics.title
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: "inherit",
    variant: "h6"
  }, title)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: "inherit",
    variant: "body1"
  }, children)));
});
Alert.displayName = 'Alert';
Alert.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component.
   */
  children: _propTypes["default"].node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string,
    title: _propTypes["default"].string
  }),
  /**
   * Override the icon displayed before the children.
   */
  icon: _propTypes["default"].node,
  /**
   * Callback fired when the component requests to be closed. When provided
   * a close icon button is displayed that triggers the callback when clicked.
   */
  onClose: _propTypes["default"].func,
  /**
   * The severity of the alert. This defines the color and icon used.
   */
  severity: _propTypes["default"].oneOf(['error', 'info', 'success', 'warning']),
  /**
   * The title of the Alert.
   */
  title: _propTypes["default"].string
} : {};
var _default = Alert;
exports["default"] = _default;